module.exports = __webpack_public_path__ + "static/FY_2023_Investor_call_Dial-in_information-d701873eef86b978bd4cb8a830c6cf6f.pdf";